import {EventEmitter} from "@angular/core";
import {Api} from "../api.service";
export class Settings {
    private _apiUrl : string;
    private _debug  : boolean;
    private _eventEmitter: EventEmitter<number>;
    private _api : Api;

    public token  : string;

    constructor(api: Api, apiUrl: string, debug: boolean, eventEmitter: EventEmitter<number>) {
        this._api    = api;
        this._apiUrl = apiUrl;
        this._debug  = debug;
        this._eventEmitter = eventEmitter;
    }

    get api(): Api {
        return this._api;
    }

    get apiUrl(): string {
        return this._apiUrl;
    }

    get debug(): boolean {
        return this._debug;
    }

    get eventEmitter(): EventEmitter<number> {
        return this._eventEmitter;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/settings.model.ts